import { IZone } from './zone.model';

export interface ISite {
  id?: number;
  name?: string;
  address?: string;
  zones?: IZone[];
}

export const defaultValue: Readonly<ISite> = {};
